import smoothScroll from 'smoothscroll-polyfill';
import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom';
import App from './App';
import { createBrowserHistory } from 'history';
import { Integrations as TracingIntegrations } from '@sentry/tracing';
import Cookies from 'js-cookie';
import amplitude from 'amplitude-js';
import getRuntimeEnv from 'helpers/env';

smoothScroll.polyfill();

const history = createBrowserHistory();
const cookie = Cookies.get('user_v2');
const env = getRuntimeEnv();

let user;

if (cookie) {
  user = JSON.parse(cookie);
}

if (env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: env.REACT_APP_SENTRY_DSN,
    environment: env.REACT_APP_ENV_NAME || process.env.NODE_ENV,
    debug: env.NODE_ENV === 'development',
    release: env.REACT_APP_VERSION,
    ignoreErrors: [
      'GATEWAY_TIMEOUT',
      /loading chunk/i,
      'ResizeObserver loop limit exceeded',
    ],
    integrations: [
      new TracingIntegrations.BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
      }),
    ],
    // To set a uniform sample rate
    tracesSampleRate: 0.2,
  });

  if (user) {
    // Attach the user to the Sentry reporting agent
    Sentry.configureScope((scope) => {
      scope.setUser({
        id: user.id,
        name: user.name,
        email: user.email,
        groups: user.groups,
        isExternal: user.isExternal,
      });
    });
  }
}

if (env.REACT_APP_AMPLITUDE_KEY && amplitude) {
  const amplitudeClient = amplitude.getInstance();
  amplitudeClient.setVersionName(env.REACT_APP_VERSION);

  amplitudeClient.init(
    env.REACT_APP_AMPLITUDE_KEY,
    user ? user.id : undefined,
    {
      includeReferrer: true,
    },
    function () {
      console.info('Amplitude init completed');
    }
  );
}

ReactDOM.render(<App />, document.getElementById('root'));
